/// <reference path="LayoutDesigner.js"/>
/// <reference path="IconShape/IconShapeUI.js"/>
/// <reference path="../../Scripts/underscore.js" />
(function (sb) {
    sb.LayoutDesigner = (sb.LayoutDesigner || {});
  
    var UserEvents = {

		drilldowns: [],
		dataKey: "userEvents",
		tooltipDataKey: "tooltipEvent",

        addEventsToElement: function(element) {
            var events = [];
            var hasLinkEvent;
            var createEvent = this.createEvent;
            var eventsData = $(element).data("user-events") || 
                $(element).find("[data-user-events]").data("user-events");
            
            if (eventsData && typeof eventsData === 'object') {
                var layoutElementVersion = Storyboard.LayoutDesigner.UserEvents.getLayoutElementVersion(element)
                hasLinkEvent = eventsData.filter(function(layoutElementEvent) {
                    return layoutElementEvent.name === 'Link'; }
                ).length > 0;
                if (layoutElementVersion < Storyboard.Constants.LayoutElementVersion.TFS22340) {
                    eventsData.forEach(function (layoutElementEvent) {
                        var newEvent = createEvent(element, layoutElementEvent);
                        if (newEvent.bind && !(layoutElementEvent.name === 'Popover' && hasLinkEvent)) {
                            newEvent.bind();
                            events.push(newEvent);
                        }
                    });
                }
                else {
                    eventsData.forEach(function (layoutElementEvent) {
                        if (layoutElementEvent.element == undefined && layoutElementEvent.report == Storyboard.LayoutDesigner.getLayoutGrid().reportId && layoutElementEvent.slide > Storyboard.LayoutDesigner.getLayoutSlides().length) {
                            Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(element);
                        }
                        else {
                            var newEvent = createEvent(element, layoutElementEvent);
                            if (newEvent.bind && !(layoutElementEvent.name === 'Popover' && hasLinkEvent)) {
                                newEvent.bind();
                                events.push(newEvent);
                            }
                        }
                        if (layoutElementEvent.element == undefined && layoutElementEvent.report != Storyboard.LayoutDesigner.getLayoutGrid().reportId) {
                            Storyboard.LayoutDesigner.getNumberOfSlides(layoutElementEvent.report, layoutElementEvent.slide, Storyboard.LayoutDesigner.getLayoutGrid().reportId, element);
                        }
                        
                    });
                }
                
                $(element).removeData("user-events").removeAttr("data-user-events");
                $(element).find("[data-user-events]")
                    .removeData("user-events").removeAttr("data-user-events");

                $(element).data(this.dataKey, events);
            } 
		},

		addEventsToChart: function (element, chartOptions, userEvents) {
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(element);

			var events = [];
			var createEvent = this.createEvent;

			if (chartOptions && userEvents) {
				var eventsData = jQuery.parseJSON(userEvents);

				if (eventsData && typeof eventsData === 'object') {
					eventsData.forEach(function (chartEvent) {
						var newEvent = createEvent(element, chartEvent);
						if (newEvent.bindToChart) {
							newEvent.bindToChart(chartOptions);
							events.push(newEvent);
						}
					});
				}

				$(element).removeData("user-events").removeAttr("data-user-events");
				$(element).find("[data-user-events]")
					.removeData("user-events").removeAttr("data-user-events");

				$(element).data(this.dataKey, events);
			}
		},

		addEventsToTable: function (element, userEvents) {
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(element);

			var events = [];
			var createEvent = this.createEvent;

			if (userEvents) {
				var eventsData = jQuery.parseJSON(userEvents);

				if (eventsData && typeof eventsData === 'object') {
					eventsData.forEach(function (chartEvent) {
						var newEvent = createEvent(element, chartEvent);
						if (newEvent.bindToTable) {
							newEvent.bindToTable();
							events.push(newEvent);
						}
					});
				}

				$(element).removeData("user-events").removeAttr("data-user-events");
				$(element).find("[data-user-events]")
					.removeData("user-events").removeAttr("data-user-events");

				$(element).data(this.dataKey, events);
			}
		},

        addTooltipToElement: function (element, message, position) {
            var createEvent = this.createEvent;

			var tooltipOptions = {
				name: "Tooltip",
				type: "hover",
				styles: {
					borderColor: "#e5a0b2",
					backgroundColor: "#FFE1E2",
					fontFamily: '"open_sans", "Helvetica Neue", Arial, Helvetica, "sans-serif"',
					color: "#E7415D",
					textAlign: "left"
				},
				text: message,
				position: position,
				tetherOptions: {
					constraints: [
						{
							to: 'scrollParent',
							pin: true
						}
					]
				}
			};

			var tooltipEvent = createEvent(element, tooltipOptions);
			if (tooltipEvent.bind)
				tooltipEvent.bind();

			$(element).data(this.tooltipDataKey, tooltipEvent);
        },

        getLayoutElementVersion: function (element) {
            var layoutElementId = $(element).closest(".layoutElement").attr("layoutelementid");

            return layoutElementId != null ? sb.LayoutDesigner.getLayoutElementByIdOrGuid(layoutElementId).version : Storyboard.Constants.LayoutElementVersion.TFS22340;
        },

        removeEventsFromElement: function(element) {
            var events = $(element).data(this.dataKey);
    
            if (events) {
                for (var i = events.length - 1; i > -1; i--)
                    events[i].destroy();

                $(element).removeData(this.dataKey).unbind("." + this.dataKey);
                $(element).removeData('user-events').removeAttr('data-user-events');
            }
		},

		removeTooltipFromElement: function (element) {
			var tooltipEvent = $(element).data(this.tooltipDataKey);

			if (tooltipEvent) {
				tooltipEvent.destroy();

				$(element).removeData(this.tooltipDataKey).unbind('.' + this.tooltipDataKey);
			}
		},

        removeEvent: function(element, layoutElementEvent) {
            var events = $(element).data(UserEvents.dataKey);
            if (events) {
                var index = events.indexOf(layoutElementEvent);
                if (index > -1) events.splice(index, 1);
            }
        },

        findEvent: function(element, name, key) {
            var events = $(element).data(UserEvents.dataKey);

            if (events)
                for (var i = 0; i < events.length; i++)
                    if (events[i].options.name === name) {
                        if (key)
                            if (events[i].options.key === key)
                                return events[i];
                            else 
                                continue;

                        return events[i];
                    }

            return null;
        },

        getEventsOptions: function(element) {
            var events = $(element).data(this.dataKey);
            var eventsData;

            if (events && events.length > 0) {
                eventsData = events.map(function(layoutElementEvent) {
                    delete layoutElementEvent.options.active;
                    delete layoutElementEvent.options.originalValue;
                    return layoutElementEvent.options;
                });
            } else {
                return '';
            }

            return JSON.stringify(eventsData);
        },

        createEvent: function(element, options) {
            var layoutElementEvent;
            
            if (options.name === "Link")
                layoutElementEvent = new LinkEvent(element, options);
            else if (options.name === "Style")
				layoutElementEvent = new StyleEvent(element, options);
            else if (options.name === "Tooltip")
				layoutElementEvent = new TooltipEvent(element, options);
            else if (options.name === "Popover")
				layoutElementEvent = new PopoverEvent(element, options);

            return layoutElementEvent;
		},

		setChartEventsTabUI: function (eventsData, previewEl) {
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divChart')[0]);
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divTable')[0]);

			$('#chartEvents').append($('#layoutElementUserEvents').css('display', ''));
			$('#layoutElementUserEvents > .collapsable').removeClass('collapsable').addClass('expandable');
			$('#layoutElementUserEvents').find('input, select, textarea').unbind();

			$('#ddlLayoutElementLinkType > span > option').unwrap();
			$('> option[value="Back"], > option[value="Url"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();
			if (window.IsDrilldown)
                $('> option[value="SBLink"], > option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
            if (!Storyboard.GeneralSettings.hasFormReports())
                $('> option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
			if (!Storyboard.GeneralSettings.hasDrilldownReports())
				$('> option[value="DrilldownLink"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();
			
			$('#chkLayoutElementStyleTextColorEvent').closest('.settingItem').show();
			$('#chkLayoutElementStyleOpacityEvent').closest('.settingItem').hide();
			Storyboard.LayoutDesigner.UserEvents.setLabelTexts(ChartSetupDataBinding.GetBoundContentType());

			$(previewEl).removeAttr('data-user-events');
			if (eventsData) {
				$(previewEl).attr('data-user-events', eventsData);
			}

			Storyboard.LayoutDesigner.UserEvents.addEventsToElement(previewEl);

			var events = $(previewEl).data(this.dataKey);

			if (events)
				events.forEach(function (layoutElementEvent) {
					layoutElementEvent.enable();
				});
			else
				events = $(previewEl).data(this.dataKey, []).data(this.dataKey);

			UserEvents.bindEventEnablers(previewEl, events);
		},

		setAdvancedAnalyticsEventsTabUI: function (eventsData, previewEl) {
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divChart')[0]);
			Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divTable')[0]);

			$('#aa_events').append($('#layoutElementUserEvents').css('display', ''));
			$('#layoutElementUserEvents > .collapsable').removeClass('collapsable').addClass('expandable');
			$('#layoutElementUserEvents').find('input, select, textarea').unbind();

			$('#ddlLayoutElementLinkType > span > option').unwrap();
			$('> option[value="Back"], > option[value="Url"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();
			
			if (!Storyboard.GeneralSettings.hasFormReports())
				$('> option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
			if (!Storyboard.GeneralSettings.hasDrilldownReports())
				$('> option[value="DrilldownLink"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();
			
			$('#chkLayoutElementStyleTextColorEvent').closest('.settingItem').show();
			$('#chkLayoutElementStyleOpacityEvent').closest('.settingItem').hide();
			Storyboard.LayoutDesigner.UserEvents.setLabelTexts(Storyboard.Constants.itemTypes.ADVANCEDANALYTICS);

			$(previewEl).removeAttr('data-user-events');
			if (eventsData) {
				$(previewEl).attr('data-user-events', eventsData);
			}

			Storyboard.LayoutDesigner.UserEvents.addEventsToElement(previewEl);

			var events = $(previewEl).data(this.dataKey);

			if (events)
				events.forEach(function (layoutElementEvent) {
					layoutElementEvent.enable();
				});
			else
				events = $(previewEl).data(this.dataKey, []).data(this.dataKey);

			UserEvents.bindEventEnablers(previewEl, events);
		},

		setLabelTexts: function (itemType) {
			if (itemType == Storyboard.Constants.itemTypes.STATICTEXT ||
				itemType == Storyboard.Constants.itemTypes.ICONSHAPE) {
				$('#hStyleEventText').text('Styles');
				$('label[for="chkLayoutElementStyleColorEvent"]').text('Color');
				$('#chkLayoutElementStyleColorEvent').closest('.settingLabel').css('width', '40%');
				$('#txtLayoutElementStyleColorEvent').closest('.settingControl').css('width', '60%');
			} else {
				var prefix = itemType == Storyboard.Constants.itemTypes.CHART || itemType == Storyboard.Constants.itemTypes.ADVANCEDANALYTICS ? 'Chart' : 'Table';
				$('#hStyleEventText').text(prefix + ' styles');
				$('label[for="chkLayoutElementStyleColorEvent"]').text(prefix + ' background color');
				$('#chkLayoutElementStyleColorEvent').closest('.settingLabel').css('width', '60%');
				$('#txtLayoutElementStyleColorEvent').closest('.settingControl').css('width', '40%');
			}
		},

        setEventsTabUI: function(layoutElementItem, previewSvgEl) {
            IconShapeUI.EventsManager.removeEventsFromSvgElement(previewSvgEl);
            Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divChart')[0]);
            Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divTable')[0]);

			$('#is_events').append($('#layoutElementUserEvents'));
			$("#layoutElementUserEvents").css("display", "").find("input, select, textarea").unbind();

			$('#ddlLayoutElementLinkType > span > option').unwrap();
			if (window.IsDrilldown)
                $('> option[value="SBLink"], > option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
            if (!Storyboard.GeneralSettings.hasFormReports())
                $('> option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
			if (!IconShapeSetup.libraryEdit || !Storyboard.GeneralSettings.hasDrilldownReports())
				$('> option[value="DrilldownLink"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();
			if (IconShapeSetup.libraryEdit)
				$('> option[value="Back"], > option[value="Url"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();

			$('#chkLayoutElementStyleTextColorEvent').closest('.settingItem').hide();
            $('#chkLayoutElementStyleOpacityEvent').closest('.settingItem').show();
            $("#layoutElementUserEvents > .expandable").removeClass('expandable').addClass('collapsable');
            
			Storyboard.LayoutDesigner.UserEvents.setLabelTexts(Storyboard.Constants.itemTypes.ICONSHAPE);

            if (layoutElementItem && layoutElementItem.content) {
                var svgFragment = $('<div/>').html(layoutElementItem.content);
                var eventsData = svgFragment.find('svg[data-user-events]').attr("data-user-events");
                if (eventsData && eventsData !== "") $(previewSvgEl).attr('data-user-events', eventsData);
                svgFragment.remove();
            }
            else {
                $('#chkLayoutElementLinkEvent').attr('disabled', false);
                $("#chkLayoutElementPopoverEvent").attr("checked", false);
                $("#chkLayoutElementTooltipEvent").attr("checked", false);
                $("#layoutElementUserEvents .settingsGroup, #layoutElementUserEvents .settingsTable").css('display', 'none');
            }

            IconShapeUI.EventsManager.addEventsToSvgElement(previewSvgEl);

            var events = $(previewSvgEl).data(this.dataKey);
            
            if (events)
                events.forEach(function(layoutElementEvent) {
                    layoutElementEvent.enable();
                }); 
            else
                events = $(previewSvgEl).data(this.dataKey, []).data(this.dataKey);

            UserEvents.bindEventEnablers(previewSvgEl, events);
        },

        setEventsWindowUI: function (element) {
            Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divChart')[0]);
            Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement($('#divTable')[0]);
            var events = $(element).data(this.dataKey);
            if (!events)
                events = $(element).data(this.dataKey, []).data(this.dataKey);

            this.eventsWindow = new DUIwindow2({
                title: '<h2>Events</h2>',
                width: 680,
                height: 'auto',
                topPosition: '40px',
                closeButton: false,
                preWrapSpace: false,
                buttons: [{
                    text: 'Continue',
                    focused: true,
                    closeWindow: true
                }],
                afterShow: function() {
                    $(this.windowEl).find(".DUI-WINDOW-BODY").css("padding-top", 0)
                        .append($("#layoutElementUserEvents").css("display", ""));
                    $("#layoutElementUserEvents > .collapsable").removeClass('collapsable').addClass('expandable');
					$("#layoutElementUserEvents").find("input, select, textarea").unbind();

					$('#chkLayoutElementStyleTextColorEvent').closest('.settingItem').hide();
					$('#chkLayoutElementStyleOpacityEvent').closest('.settingItem').show();
					Storyboard.LayoutDesigner.UserEvents.setLabelTexts(Storyboard.Constants.itemTypes.STATICTEXT);

					$('#ddlLayoutElementLinkType > span > option').unwrap();
					if (window.IsDrilldown)
                        $('> option[value="SBLink"], > option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
                    if (!Storyboard.GeneralSettings.hasFormReports())
                        $('> option[value="APLink"]', $('#ddlLayoutElementLinkType')).remove();
					$('> option[value="DrilldownLink"]', $('#ddlLayoutElementLinkType')).wrap('<span>').parent().hide();

                    events.forEach(function(layoutElementEvent) {
                        layoutElementEvent.enable();
                    });

                    UserEvents.makeCollapsable();
                    UserEvents.bindEventEnablers(element, events);
                    UserEvents.showMultilanguageNote();
                },
                beforeClose: function() {
                    $("#is_events").append($("#layoutElementUserEvents").css("display", ""));
                    if (events && events.length > 0)
                        $(".mce-btn[aria-label='Events']").addClass("mce-active");
                    else
                        $(".mce-btn[aria-label='Events']").removeClass("mce-active");

                    var hasLinkEvent = events.filter(function (event) {
                        return event.options.name === 'Link';
                    }
                    ).length > 0;
                    // Remove old link implementation
                    if (hasLinkEvent)
                        $(element).find("a.SBLink").remove();
                    events.forEach(function(layoutElementEvent) {
                        layoutElementEvent.disable();
                    });
                }
            });
        },

        bindEventEnablers: function(element, events) {
            $("#txtLayoutElementStylePaddingEvent").closest('.settingItem').toggle($(element).is("svg"));

            $("#layoutElementUserEvents").undelegate(".enablelayoutElementEvent", "change")
                .delegate(".enablelayoutElementEvent", "change", function() {
                    var id = this.id;
                    var layoutElementEvent;

                    if (!this.checked) return;
                    
                    if (id === "chkLayoutElementLinkEvent") {
                        layoutElementEvent = UserEvents.createEvent(element, {name: "Link"});
						var popoverEvent = UserEvents.findEvent(element, "Popover");
						if (popoverEvent) popoverEvent.destroy();
					} else if (id === "chkLayoutElementPopoverEvent") {
                        layoutElementEvent = UserEvents.createEvent(element, {name: "Popover"});
						var linkEvent = UserEvents.findEvent(element, "Link");
						if (linkEvent) linkEvent.destroy();
					} else if (id === "chkLayoutElementStyleColorEvent")
						layoutElementEvent = UserEvents.createEvent(element, { name: "Style", key: "color" });
					else if (id === "chkLayoutElementStyleTextColorEvent")
						layoutElementEvent = UserEvents.createEvent(element, { name: "Style", key: "textColor" });
                    else if (id === "chkLayoutElementStyleOpacityEvent")
                        layoutElementEvent = UserEvents.createEvent(element, {name: "Style", key: "opacity"});
                    else if (id === "chkLayoutElementStylePaddingEvent")
                        layoutElementEvent = UserEvents.createEvent(element, {name: "Style", key: "padding"});
                    else if (id === "chkLayoutElementTooltipEvent")
                        layoutElementEvent = UserEvents.createEvent(element, {name: "Tooltip"});

                    if (layoutElementEvent) {
                        events.push(layoutElementEvent);
                        layoutElementEvent.enable();
                    }
                });
        },

        // TODO: move to helpers --- used in two other places
        makeCollapsable: function () {
            $('#layoutElementUserEvents').delegate('fieldset.expandable', 'click', function (e) {
                e.stopPropagation();
                var collapseGroup = $(this).attr('data-collapse-group');
                if (collapseGroup !== undefined) {
                    $(collapseGroup).find('fieldset.collapsable').removeClass('collapsable').addClass('expandable');
                }

                $(this).removeClass('expandable').addClass('collapsable');
            });

            $('#layoutElementUserEvents').delegate('fieldset.collapsable > .advanced', 'click', function (e) {
                e.stopPropagation();
                $(this).parent().removeClass('collapsable').addClass('expandable');
            });
        },

        showMultilanguageNote: function() {
            var selectedLanguage = $("#ddlLng").val();
            var note = '<div class="Message Message-info"><b>Multilanguage note:</b><div>'+
                            '- Link and tooltip/hover styles are not language specific (the same link and style are applied to all languages)<br>'+
                            '- Tooltip texts are language specific'+
                       '</div></div>';

            if (selectedLanguage)
                $('#layoutElementUserEvents').before(note);
		},

		showMarkersMessage: function (isChart) {
			$('#msgMarkersRequired').hide();

			var isDrillDownLinkOn = $('#chkLayoutElementLinkEvent').attr('checked') && $('#ddlLayoutElementLinkType').val() == 'DrilldownLink';

			if (isDrillDownLinkOn && isChart) {
				var lineOrSpline = $('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.LINE || $('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.SPLINE;
				var markersEnabled = $('#chartstyle_series_marker_enabled').attr('checked');

				if (lineOrSpline && !markersEnabled)
					$('#msgMarkersRequired').show();
			}
		},

        setDefaults: function (settings) {
            if (settings.defaultFont) {
                TooltipEvent.Default.styles.fontFamily = Object.freeze(settings.defaultFont);
            }
            if (settings.fonts) {
                TooltipEvent.Default.fonts = settings.fonts;
            }
        },

        getFontStackByFontFamily: function (fontFamily) {
            var fonts = TooltipEvent.Default.fonts;
            var fontsLength = fonts.length;
            
            for (var i = 0; i < fontsLength; i++)
                if (fonts[i].family === fontFamily)
                    return fonts[i].fontStack;

            return fontFamily;
        },


        closeAllTooltips: function() {
            $('.tooltip-target.tooltip-enabled, .drop-target.drop-enabled', '#layoutArea')
                .each(function() {
                    var events = $(this).data(UserEvents.dataKey);
                    if (events && typeof events === 'object') {
                        events.forEach(function(event) {
                            if (event.options.name === 'Tooltip' && event.tooltip) event.tooltip.close();
                            if (event.options.name === 'Popover' && event.popover) event.popover.close();
                        });
                    }
                });
        }
    };

    var LinkEvent = function(element, options){
		this.options = options;
        this.element = element;
        this.options.type = "click";
        this.options.name = "Link";
        this.namespace = "click." + UserEvents.dataKey + ".Link";
    };

    LinkEvent.prototype = {

        constructor: LinkEvent,

        setDefaults: function() {
            this.options = {};
            this.options.type = "click";
            this.options.name = "Link";
        },

        trigger: function(pointGuid) {
            if (this.options.back)   window.history.back();
            if (this.options.url)    this.triggerURL();
            if (this.options.report) {
                if (this.options.isActionPlan)
                    this.triggerAPLink();
				else if (this.options.isDrilldown)
                    this.triggerDrilldownLink(pointGuid);
				else
					this.triggerSBLink();
			}
		},

		triggerDrilldownLink: function (pointGuid) {
			var linkEvent = this;

			if (!Storyboard.GeneralSettings.hasDrilldownReports())
				return;

			function setDrilldownSettings(guid, settings, callback) {
				Helpers.perfJSonCall({
					data: { guid: guid, settings: settings },
					method: 'SetDrilldownSettings',
					service: 'ReportService',
					successCallback: function () {
						if (callback) callback(guid);
					}
				});
			}

			function openDrilldownReport(settingsGuid) {
				var targetReportId = linkEvent.options.report;

				var drilldownMatches = $.grep(Storyboard.LayoutDesigner.UserEvents.drilldowns, function (d) { return d.targetReportId == targetReportId; });
				if (drilldownMatches.length < 1)
					return;

				var ifrDrilldownReportID = drilldownMatches[0].iframe;

				var doc = document;
				if (self !== top && !isCrossOrigin() && top.IsStoryboard) {
					doc = parent.document;
				}

                var iframeEl = doc.getElementById(ifrDrilldownReportID);
                if (!iframeEl) return;
				var iframeContent;
				if (iframeEl.contentWindow) {
					iframeContent = iframeEl.contentWindow;
				} else if (iframeEl.contentDocument && iframeEl.contentDocument.documentElement) {
					iframeContent = iframeEl.contentDocument.documentElement;
				}

                if (iframeContent.Storyboard !== undefined) {
                    iframeContent.Storyboard.LayoutDesigner.clearAllLoadedContent();
                    iframeContent.Storyboard.LayoutDesigner.loadDrilldownContent(settingsGuid, linkEvent.options.slide, linkEvent.options.element);
                }

				var drilldownWin = drilldownMatches[0].duiWindow;
				$(drilldownWin.windowEl).parent().removeClass('sr-only');
				$(document.body).parent().addClass('DUI-WINDOW-LOCK');
				iframeContent.focus();
			}

			var leGuid = (this.element.nodeName.toUpperCase() === 'SVG' ? $(this.element).closest('.layoutElement') : $(this.element)).attr('guid');
			var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid(leGuid);
			var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
            var cachedContent;
			if (elementType == Storyboard.Constants.itemTypes.DYNAMICICONSHAPE) {
				var leItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
				cachedContent = Storyboard.DynamicIconShapeCache.getDynamicIconShapeContentFromCache(leItem.guid);
				if (cachedContent && cachedContent.DrilldownSettings) {
					setDrilldownSettings(leItem.guid, cachedContent.DrilldownSettings, openDrilldownReport);
				}
			} else {
				cachedContent = Storyboard.LayoutDesigner.getCachedContent(layoutElement);

				if (cachedContent && pointGuid) {
					var drilldownSettings = cachedContent.drilldownSettings;

					if (drilldownSettings && drilldownSettings.hasOwnProperty(pointGuid)) {
						setDrilldownSettings(pointGuid, drilldownSettings[pointGuid], openDrilldownReport);
					}
				}
			}
        },

        triggerSBLink: function() {
            var reportId = Helpers.getReportID();
			var targetReportId = this.options.report;
            var targetSlide = this.options.slide;
            var layoutElementVersion = Storyboard.LayoutDesigner.UserEvents.getLayoutElementVersion(this.element);
            var selectedHFilterIDs;

            function updateElementsIfNeeded() {
                if (updateLayoutElements && !updateHFilter)
                    sb.LayoutDesigner.updateLayoutElements();
            }

            if (targetReportId == reportId) {
                if (this.options.element) {
                    if (Storyboard.LayoutDesigner.setPageNoByLayoutElementId(this.options.element) > -1 && $('div.DUIslideNavigator').length > 0) {
                        Storyboard.LayoutDesigner.scrollPageIntoLayoutElement(this.options.element);
                    }
                }
                else {
                    var currentSlide = Storyboard.LayoutDesigner.getCurrentPageNo();
                    if (targetSlide != currentSlide)
                        if (layoutElementVersion < Storyboard.Constants.LayoutElementVersion.TFS22340 || Storyboard.LayoutDesigner.getLayoutSlides().length >= targetSlide)
                            Storyboard.LayoutDesigner.setCurrentPageNo(parseInt(targetSlide, 10));
                }

                if (this.options.useOptionalFilters && this.options.optionalFilters) {
                    var updateLayoutElements = false;
                    var updateHFilter = false;

                    if (this.options.optionalFilters.useVariableSubset && $('#lbSetting_1').length) {
                        $('#lbSetting_1').val(this.options.optionalFilters.variableSubsetSelections);
                        $('#lbSetting_1').multiselect('refresh');
                        updateLayoutElements = true;
                    }

                    if (this.options.optionalFilters.useIntervals && $('#lbSetting_2').length) {
                        $('#lbSetting_2').val(this.options.optionalFilters.intervalSelections);
                        $('#lbSetting_2').multiselect('refresh');
                        updateLayoutElements = true;
                    }

                    if (this.options.optionalFilters.useMovingAverage && $('#lbSetting_4').length) {
                        $('#lbSetting_4').val(this.options.optionalFilters.movingAverageSelections);
                        $('#lbSetting_4').multiselect('refresh');
                        updateLayoutElements = true;
                    }

                    if (this.options.optionalFilters.useOFilters) {
                        if ($('#lbSetting_5').length) {
                            $('#lbSetting_5').val(this.options.optionalFilters.oFiltersSelections);
                            $('#lbSetting_5').multiselect('refresh');
                            updateLayoutElements = true;
                        } else {
                            var $ddls = $("[id^='lbSetting_5_'");
                            var oFilterSelections = this.options.optionalFilters.oFiltersSelections;
                            $ddls.each(function () {
                                var ddlValues = [];
                                var filterId = $(this).attr("id").split('_')[2];
                                $(this).children('option').each(function () { ddlValues.push($(this).val()); });
                                var toSelect = oFilterSelections
                                    .filter(function (val) { return val.split('-')[0] === filterId; })
                                    .map(function (val) { return val.split('-')[1] === '0' ? '0-0' : val; });
                                var valuesToSelect = $(ddlValues).filter(toSelect);
                                if (valuesToSelect.length > 0) {
                                    $(this).val(valuesToSelect);
                                    $(this).multiselect('refresh');
                                    updateLayoutElements = true;
                                }  
                            });
                        }
                    }

                    if (this.options.optionalFilters.useTimePeriods && $('#lbSetting_3').length) {
                        $('#lbSetting_3').val(this.options.optionalFilters.timePeriodsSelections);
                        $('#lbSetting_3').multiselect('refresh');
                        updateLayoutElements = true;
                    }

                    if (this.options.optionalFilters.useHFilters) {
                        updateLayoutElements = true;
                        updateHFilter = true;
                        selectedHFilterIDs = this.options.optionalFilters.hFiltersSelections.SettingItems.map(function(settingItem) {
                            return parseInt(settingItem.DisplayID, 10);
                        });
                        setSelectedHFilter(selectedHFilterIDs, function() {
                            reloadHFilterControl();
                            sb.LayoutDesigner.updateLayoutElements();
                        });
                    }

                    if (Storyboard.DynamicFiltering.isEnabled())
                        $.when(Storyboard.DynamicFiltering.reportLoadDynamicFiltering()).then(updateElementsIfNeeded);
                    else
                        updateElementsIfNeeded();
                }
			} else {
				if (this.options.element)
					$.cookie('SBLink', 'elementId:' + this.options.element + '|reportId:' + this.options.report);

                if (this.options.useOptionalFilters && this.options.optionalFilters) {
                    if (this.options.optionalFilters.useVariableSubset && this.options.optionalFilters.variableSubsetSelections)
                        $.cookie('SBLinkVariableSubsets', JSON.stringify(this.options.optionalFilters.variableSubsetSelections));

                    if (this.options.optionalFilters.useIntervals && this.options.optionalFilters.intervalSelections)
                        $.cookie('SBLinkIntervals', JSON.stringify(this.options.optionalFilters.intervalSelections));

                    if (this.options.optionalFilters.useMovingAverage && this.options.optionalFilters.movingAverageSelections)
                        $.cookie('SBLinkMovingAverage', JSON.stringify(this.options.optionalFilters.movingAverageSelections));

                    if (this.options.optionalFilters.useOFilters && this.options.optionalFilters.oFiltersSelections)
                        $.cookie('SBLinkOptionalFilters', JSON.stringify(this.options.optionalFilters.oFiltersSelections));

                    if (this.options.optionalFilters.useTimePeriods && this.options.optionalFilters.timePeriodsSelections)
                        $.cookie('SBLinkTimePeriods', JSON.stringify(this.options.optionalFilters.timePeriodsSelections));

                    if (this.options.optionalFilters.useHFilters) {
                        selectedHFilterIDs = this.options.optionalFilters.hFiltersSelections.SettingItems.map(function(settingItem) {
                            return parseInt(settingItem.DisplayID, 10);
                        });
                        setSelectedHFilter(selectedHFilterIDs, redirectReport);
                        updateHFilter = true;
                    }
                }

                if (!updateHFilter) {
                    if (layoutElementVersion < Storyboard.Constants.LayoutElementVersion.TFS22340)
                        redirectReport();
                    else
                        Storyboard.LayoutDesigner.getNumberOfSlides(targetReportId, targetSlide, reportId, -1);
                }
                    
            }
            function setSelectedHFilter(hFilterIDs, callback) {
                Helpers.perfJSonCall({
                    method: 'SetSelectedHFilters',
                    data: { selectedHFilters: hFilterIDs },
                    successCallback: callback
                });
            }

            function reloadHFilterControl() {
                var hFilterLayout = Storyboard.LayoutDesigner.getHFilterLayout();
                var hFilterSelectionMode = Storyboard.LayoutDesigner.getHFilterSelectionMode();
                GeneralSettings.loadHFilter(hFilterLayout, null);
                GeneralSettings.reloadHFilter(hFilterLayout, hFilterSelectionMode);
            }

            function redirectReport() {
				var newLocation = window.location.href.replace("RpId=" + reportId, "RpId=" + encodeURIComponent(targetReportId));
				if (targetSlide) {
					if (newLocation.indexOf('slide=') > -1)
						newLocation = newLocation.replace('slide=' + Helpers.getURLParameter('slide'), 'slide=' + encodeURIComponent(targetSlide));
					else
						newLocation += '&slide=' + encodeURIComponent(targetSlide);
				}
                if (window.IsMyStories)
                    newLocation = newLocation.replace("MyStories.aspx", "RHViewStoryBoard.aspx");
                window.location.href = newLocation;
            }
        },

        triggerAPLink: function () {
            // TODO: implement trigger logic

            //From respondent table
            //var respondentId = parseInt($(this).parent().find("#hidRespId").val(), 10);
            //var editable = $(this).parent().find("#hidIsFormEditable").val() && $(this).parent().find("#hidIsFormEditable").val().toLowerCase() == "true";
            var options = this.options;

            var settingSelections = [];

            var filterSettings = GeneralSettings.getSelectedSettings().filter(function (el) { return el.SettingType == 5; });
            if (filterSettings.length) {
                var selectedValues = filterSettings[0].SelectedSettings.split(',').filter(function (ee) { return options.APFilters.some(function (eee) { return eee != 0 && ee.indexOf(eee + '-') === 0; }); });
                if (selectedValues.length)
                    settingSelections.push({
                        SettingType: 5,
                        SelectedValues: selectedValues
                    });
            }

            if (options.APFilters.indexOf(0) !== -1) {
                var hfilterSettings = GeneralSettings.getSelectedSettings().filter(function (el) { return el.SettingType == 6; });

                if (hfilterSettings.length)
                    settingSelections.push({
                        SettingType: 6,
                        SelectedValues: hfilterSettings[0].SelectedSettings.split(',')
                    });
            }

            Helpers.perfJSonCall({
                data: {
                    reportId: options.report,
                    respondentId: 0,
                    isFormEditable: false,
                    settingSelections: settingSelections
                },
                successCallback: function (result) {
                    RespondentTableSetup.openFormReport(result.url, '', options.APObjects, false, 0, null, false, true);
                },
                message: locale.get('Loading action plan form'),
                method: 'GetFormReportUrl',
                service: "ReportService",
                fixCasing: true
            });
        },

        triggerURL: function() {
            if (this.options.openInNewWindow) 
                window.open(this.options.url, "_blank");
            else
                window.location.href = this.options.url;
		},

		createDrilldownIframe: function () {
			if (Storyboard.GeneralSettings.hasDrilldownReports() && this.options.isDrilldown && this.options.report > 0) {
				var reportId = Helpers.getReportID();
				var targetReportId = this.options.report;

				if ($.grep(Storyboard.LayoutDesigner.UserEvents.drilldowns, function (d) { return d.targetReportId == targetReportId; }).length > 0)
					return;

				var ifrDrilldownReportID = 'ifrDrilldownReport_' + reportId + '_' + targetReportId + '_' + Helpers.generateGuid();

				var drilldownInfo = { iframe: ifrDrilldownReportID, targetReportId: targetReportId };
				Storyboard.LayoutDesigner.UserEvents.drilldowns.push(drilldownInfo);

				var drilldownHTML = "<iframe id='" + ifrDrilldownReportID + "' class='drilldownStoryTeller' style='width:100%;height:100%;border: 0;' scrolling='no' />";
				var win = window, doc = document;

				if (self !== top && !isCrossOrigin() && top.IsStoryboard) {
					win = parent;
					doc = parent.document;
				}

				var drilldownWin = new win.DUIwindow2({
					title: '',
					height: 766,
					padding: 0,
					preWrapSpace: false,
					html: drilldownHTML,
					cssClass: 'drilldownStoryTellerWindow',
                    beforeClose: function () {
                        $(this.windowEl).parent().addClass('sr-only');
						$(doc.body).parent().removeClass('DUI-WINDOW-LOCK');
						window.focus();

						var iframeEl = doc.getElementById(ifrDrilldownReportID);
						if (iframeEl.getAttribute("wasUpdated") == 1) {
							if ($('#pnlSettingsPanel .SettingsControl[isInputVariable]').length > 0) {
								Storyboard.LayoutDesigner.loadStorytellerContent();
							} else {
								var objsToUpdate = Storyboard.LayoutDesigner.getLayoutElementsWithInputVars();
								if (objsToUpdate && objsToUpdate.length > 0)
									Storyboard.LayoutDesigner.loadStorytellerContentForElements(objsToUpdate, true, true);
							}
                        }
                        const iframeDocument = iframeEl.contentDocument || iframeEl.contentWindow.document;
                        const iframeElVideos = iframeDocument.querySelectorAll('video');                        
                            iframeElVideos.forEach(video => {
                                video.pause();
                                video.currentTime = 0;
                                video.load();
                            });
                        window.DUIWindowScrollbar.resetScrollbar();
						return false;
					}
				});

				drilldownWin.Close();
				drilldownInfo.duiWindow = drilldownWin;
				
				$(drilldownWin.windowEl).parent().addClass('sr-only');
				$(doc.body).parent().removeClass('DUI-WINDOW-LOCK');
				$('#MessagePopup').stop(true, true);

				var url = window.location.href.replace('RpId=' + reportId, 'RpId=' + encodeURIComponent(targetReportId));
				if (window.IsMyStories)
					url = url.replace('MyStories.aspx', 'RHViewStoryboard.aspx');
				var iframeEl = doc.getElementById(ifrDrilldownReportID);
				$(iframeEl).attr('src', url);
			}
        },

		bindToChart: function (chartOptions) {
			this.unbind();

			if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview() || window.IsMyStories) {
				if (chartOptions) {
					var linkEvent = this;

                    if (this.options.isDrilldown) {
                        if (self != top && window.name == 'print-frame')
                            return;

						this.createDrilldownIframe();

						chartOptions.plotOptions.series.point.events = $.extend(
							chartOptions.plotOptions.series.point.events,
							{
								click: function () {
									linkEvent.trigger(this.guid);
								}
							}
						);
					}
					else {
						$(this.element).css('cursor', 'pointer');
						chartOptions.chart.events = $.extend(
							chartOptions.chart.events,
							{
								click: function () {
									linkEvent.trigger();
								}
							}
						);
						chartOptions.plotOptions.series.point.events = $.extend(
							chartOptions.plotOptions.series.point.events,
							{
								click: function () {
									linkEvent.trigger();
								},
							}
						);
					}
				}
			}
		},

		bindToTable: function () {
			this.unbind();

			if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview() || window.IsMyStories) {
                if (this.options.isDrilldown) {
                    if (self != top && window.name == 'print-frame')
                        return;

					var linkEvent = this;
					this.createDrilldownIframe();

					$('td[cellGuid]', this.element).bind('mouseover', function () {
						var originalBgColor, originalTextColor;
						if ($(this).attr('original-bg-color'))
							originalBgColor = $(this).attr('original-bg-color');
						else {
							originalBgColor = $(this).css('background-color');
							$(this).attr('original-bg-color', originalBgColor);
						}

						if ($(this).attr('original-text-color'))
							originalTextColor = $(this).attr('original-text-color')
						else {
							originalTextColor = $(this).css('color');
							$(this).attr('original-text-color', originalTextColor);
						}

						if (originalBgColor == 'rgba(0, 0, 0, 0)' || originalBgColor == 'transparent') {
							var adjustedTextColor = HTMLHelpers.getPointHoverColor(originalTextColor, 2.5);
							$(this).css('color', adjustedTextColor);
						} else {
							var adjustedColor = HTMLHelpers.getPointHoverColor(originalBgColor);
							$(this).css('background-color', adjustedColor);
						}
					});
					$('td[cellGuid]', this.element).bind('mouseleave', function () {
						$(this).css('background-color', $(this).attr('original-bg-color'));
						$(this).css('color', $(this).attr('original-text-color'));
					});

					$('td[cellGuid]', this.element)
						.css('cursor', 'pointer')
						.bind(this.namespace, function () {
							linkEvent.trigger($(this).attr('cellGuid'));
						});
				} else {
					this.bind();
				}
			}
		},

        bind: function() {
            this.unbind();

            if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview() || window.IsMyStories) {
                if (self != top && window.name == 'print-frame')
                    return;

				this.createDrilldownIframe();

				if (this.options.isDrilldown && this.element.nodeName.toUpperCase() === 'SVG' && $(this.element).parent().hasClass('layoutElementDynamicIconShape')) {
					$('g.group-styles', this.element).attr('original-fill', $('g.group-styles', this.element).attr('fill'));
					$('defs linearGradient stop', this.element).each(function () {
						$(this).attr('original-stop-color', $(this).attr('stop-color'));
					});

					$(this.element).closest('.layoutElementDynamicIconShape').bind('mouseover', function () {
						var originalColor = $('g.group-styles', this).attr('original-fill');
						if (originalColor.indexOf('url') < 0) {
							var adjustedColor = HTMLHelpers.getPointHoverColor(originalColor);
							$('g.group-styles', this).attr('fill', adjustedColor);
						} else {
							$('linearGradient stop', this).each(function () {
								$(this).attr('stop-color', HTMLHelpers.getPointHoverColor($(this).attr('original-stop-color')));
							});
						}
					});
					$(this.element).closest('.layoutElementDynamicIconShape').bind('mouseleave', function () {
						$('g.group-styles', this).attr('fill', $('g.group-styles', this).attr('original-fill'));
						$('defs linearGradient stop', this.element).each(function () {
							$(this).attr('stop-color', $(this).attr('original-stop-color'));
						});
					});
				}

				$(this.element)
					.css("cursor", "pointer")
					.bind(this.namespace, $.proxy(this.trigger, this));
			}
        },

        unbind: function() {
            $(this.element).unbind(this.namespace);
        },

        loadReports: function(reportTypeId, reportsDropdown) {
            var leEvent = this;

			Helpers.perfJSonCall({
				data: { reportTypeId: reportTypeId || 10 },
                method: 'GetReportListGeneric',
                message: 'Retreiving list of reports...',
                successCallback: function (reports) {
                    HTMLHelpers.bindSelect(reportsDropdown, reports, "ReportID", "DisplayString");
                    reportsDropdown.val(leEvent.options.report || "");
                    leEvent.options.report = reportsDropdown.val();
                    $('#divTargetReportFilterSettings').css('display', [13, 19].indexOf(reportTypeId) !== -1 ? 'none' : '');
                    
                    if (leEvent.options.useOptionalFilters) {
                        $('#chkTargetReportFilters').attr('checked', 'checked');
                        leEvent.configureFilterSection(leEvent.options.report);
                    } else {
                        $('#chkTargetReportFilters').removeAttr('checked');
                        $('#divTargetReportFilterSettingsSection').hide();
                    }

                    if (!leEvent.options.isActionPlan)
                        leEvent.loadElements();
                }
            });
        },

        loadElements: function() {
            var options = this.options;
            var reportID = $('#ddlLayoutElementLinkReports').val();

            Helpers.perfJSonCall({
                method: 'GetLayoutElementsForReport',
                data: {
                    reportID: reportID
                },
                message: 'Retrieving slides...',
                successCallback: function(layout){
                    var elements = layout.LayoutElements;
                    var slides = layout.LayoutSlides.sort(function(a, b) { return a.SlideIndex - b.SlideIndex; });
                    var opts = [];

					if (slides.length == 0)
						opts.push('<option class="slideItem" value="1">Slide 1</option>');
                    else {
						for (var slideNo = 0; slideNo < slides.length; slideNo++) {
							var slide = slides[slideNo];
							if (slide.IsBackground) continue;

                            opts.push('<option class="slideItem" value="' + slide.SlideIndex + '">Slide ' + slide.SlideIndex + '</option>');
							for (var elem in elements) {
                                if (elements.hasOwnProperty(elem)) {
									var elID = elements[elem].LayoutElementID;
									var type = Storyboard.Constants.itemTypeClearNames[elements[elem].LayoutElementItems[0].ItemType];
									if (elements[elem].SlideIndex == slide.SlideIndex) {
                                        opts.push('<option class="objectItem" value="' + elID + '">#' + elID + ' (' + type + ')</option>');
									}
								}
							}
						}
					}

                    $('#ddlLayoutElementLinkElements').html(opts.join(''));
                    if (options.element) $('#ddlLayoutElementLinkElements').val(options.element);
                    else if (options.slide){
                        $('#ddlLayoutElementLinkElements').val(options.slide);
                            if (!$('#ddlLayoutElementLinkElements :selected').hasClass('slideItem')) $('#ddlLayoutElementLinkElements').val(-1);
                    }
                }
            });
        },

        configureActionPlanSection: function (reportId) {
            var options = this.options;

            if (options.isActionPlan) {
                this.configureAPFilterSection(reportId);
                this.configureAPObjectContainer(reportId);
            } else {
                $("#tbAPFiltersContainer").hide();
                $("#tbUpdateObjectsContainer").hide();
            }
            
            // TODO: populate list with available data objects from storyteller
            // TODO: preselect saved list of objects
        },

        configureAPFilterSection: function (reportId) {
            var options = this.options;
            options.APFilters = options.APFilters || [];

            $('#tbAPFiltersContainer').children().remove();
            function configure(storyboardSettingss) {
                var storyboardSettings = storyboardSettingss.d;
                var settingTypes = sb.Constants.SettingTypes;

                if (storyboardSettings.filter(function (setting) { return setting.SettingType === settingTypes.Filter || setting.SettingType === settingTypes.HFilter }).length) {
                    $('#tbAPFiltersContainer').append('<div class="settingItem"><i>Select optional filters to be saved on action</i></div>');

                    var filterTemplate = '<div class="settingItem"><span class="settingLabel DUI-custom-checkbox"><input id="{chkId}" type="checkbox" data-settingId="{settingId}" {checked}"><label for="{chkId}">{chkLabel}</label></span></div>';
                    $.each(storyboardSettings, function () {
                        var setting = this,
                            settingItemHtml = [];

                        if (setting.SettingType === settingTypes.Filter) {
                            $.each(setting.SettingItems, function () {
                                var settingItem = this;
                                if (settingItem.Attributes !== 0) {
                                    settingItemHtml.push(
                                        filterTemplate
                                            .split('{chkId}').join('chkAPFilter_' + setting.SettingType + '_' + settingItem.DisplayID)
                                            .split('{chkLabel}').join("Filter: " + settingItem.DisplayName)
                                            .split('{settingId}').join(settingItem.DisplayID)
                                            .split('{checked}').join(_.contains(options.APFilters, parseInt(settingItem.DisplayID)) ? 'checked="checked"' : ''));
                                }
                            });
                        }
                        else if (setting.SettingType === settingTypes.HFilter) {
                            settingItemHtml.push(
                                filterTemplate
                                    .split('{chkId}').join('chkAPFilter_' + setting.SettingType)
                                    .split('{chkLabel}').join("HFilter: " + setting.Name)
                                    .split('{settingId}').join(setting.SettingId)
                                    .split('{checked}').join(_.contains(options.APFilters, parseInt(setting.SettingId)) ? 'checked="checked"' : ''));
                        }

                        $('#tbAPFiltersContainer').append(settingItemHtml.join(''));
                    });

                    $('input[id^="chkAPFilter_"]').unbind("change").bind("change", function () {
                        if ($(this).is(':checked'))
                            options.APFilters = _.union(options.APFilters, [parseInt($(this).attr('data-settingId'))]);
                        else
                            options.APFilters = _.difference(options.APFilters, [parseInt($(this).attr('data-settingId'))]);
                    });

                    $("#tbAPFiltersContainer").show();
                }
                
            }
            $.when(this.getStoryboardSettingsDF(reportId, 'Configuring optional filters...')).then(configure);
        },

        configureAPObjectContainer: function () {
            var options = this.options;
            options.APObjects = options.APObjects || [];

            function configure(data) {
                var availableElements = data.d;
                var currentLayoutElementId = $(this.element).closest(".layoutElement").attr("layoutelementid") || 0;

                $("#tbDataObjectsBox option").remove();
                if (availableElements.length > 0) {
                    var objOptions = "";
                    var types = Storyboard.Constants.itemTypeClearNames;
                    for (var i = 0; i < availableElements.length; i++) {
                        if (availableElements[i].layoutElementId != currentLayoutElementId) {
                            var title = types[availableElements[i].itemType].charAt(0).toUpperCase() + types[availableElements[i].itemType].slice(1) + ' box ' + availableElements[i].layoutElementId;
                            objOptions += '<option value="' + HTMLHelpers.htmlEncode(availableElements[i].layoutElementId) + '">' + HTMLHelpers.htmlEncode(title) + '</option>';
                        }
                    }

                    $("#tbDataObjectsBox").append(objOptions);

                    HTMLHelpers.setSelectedValues('#tbDataObjectsBox', options.APObjects);
                }

                $("#tbDataObjectsBox").unbind("change").bind("change", function () {
                    options.APObjects = $(this).val();
                });

                $("#tbUpdateObjectsContainer").show();
            }

            function loadLayoutElements() {
                return Helpers.perfJSonCall({
                    method: 'GetLayoutElementsAvailableForUpdate',
                    service: 'RespondentTableSetup',
                    message: locale.get('Loading layout elements'),
                });
            }

            $.when(loadLayoutElements()).then(configure);
        },

        configureFilterSection: function (reportId) {
            var options = this.options;

            function configureFilterSubSection(ddl, chk, useFilter, selections, optionsHtml, isMultiSelect) {
                chk.attr('checked', Boolean(useFilter));

                // Configure multiselect
                ddl.attr('multiple', isMultiSelect);
                ddl.attr('size', isMultiSelect && optionsHtml.length > 6 ? 6 : null);
                ddl.css('display', !chk.is(':checked') ? 'none' : '');

                // Append options to ddl
                ddl.html(optionsHtml.join(''));

                // Apply saved selections
                if (selections && selections.length)
                    ddl.val(selections);

                ddl.closest('.settingItem').show();
            }

            function configureSplitedFilterSubsection(settingItem, options, optionTemplate) {
                var splitedFilterSubsectionTemplate = '<div class="settingItem" style="display: none;"><span class="settingLabel DUI-custom-checkbox"><input id="{chkId}" type="checkbox" class="{chkClass}"><label for="{chkId}">{chkLabel}</label></span><select id="{ddlId}" class="settingControl" multiple="" size="6"></select></div>';

                var chkId = 'chkTargetReportOFilters_' + settingItem.DisplayID;
                var chkClass = 'enableTargetReportOFilters_' + settingItem.DisplayID;
                var chkLabel = settingItem.DisplayName;
                var ddlId = 'ddlTargetReportOFilters_' + settingItem.DisplayID;

                var optionsHtml = [];
                $.each(settingItem.SubItems, function () {
                    var subItem = this;
                    if (subItem.Attributes !== 0)
                        optionsHtml.push(optionTemplate.replace('{value}', subItem.DisplayID).replace('{text}', subItem.Name));
                });

                if (settingItem.HasNoSelection)
                    optionsHtml.unshift(optionTemplate.replace('{value}', settingItem.DisplayID + '-0').replace('{text}', 'No selection'));

                var splitedFilterSubsectionHtml =
                    splitedFilterSubsectionTemplate
                    .replace('{chkId}', chkId)
                    .replace('{chkId}', chkId)
                    .replace('{chkClass}', chkClass)
                    .replace('{chkLabel}', chkLabel)
                    .replace('{ddlId}', ddlId);

                $('#ddlTargetReportOFilters').closest('.settingItem').after(splitedFilterSubsectionHtml);

                // if there is some selection saved for current filter, restore selection and show subsection
                // else hide subsection
                var selectionsExist = _.some(options.optionalFilters.oFiltersSelections, function (value) { return value.split('-')[0] === settingItem.DisplayID });
                configureFilterSubSection($('#' + ddlId), $('#' + chkId), selectionsExist, options.optionalFilters.oFiltersSelections, optionsHtml, settingItem.UseAsMultiSelect);

                function updateSelectionsFromDropdown(ddl) {
                    var ddlValue = [];

                    if (ddl.attr("multiple")) ddlValue = ddl.val() || [];
                    else ddlValue = ddl.val() ? [ddl.val()] : [];

                    options.optionalFilters.oFiltersSelections = _.filter(options.optionalFilters.oFiltersSelections, function (value) { return value.split('-')[0] !== settingItem.DisplayID });
                    options.optionalFilters.oFiltersSelections = _.union(options.optionalFilters.oFiltersSelections, ddlValue);
                }

                $("#" + chkId).unbind("change").bind("change", function () {
                    if ($(this).is(':checked')) {
                        configureFilterSubSection($('#' + ddlId), $('#' + chkId), true, options.optionalFilters.oFiltersSelections, optionsHtml, settingItem.UseAsMultiSelect);

                        options.optionalFilters.useOFilters = true;

                        updateSelectionsFromDropdown($('#' + ddlId));

                        $('#' + ddlId).show();
                    } else {
                        // remove all selected options
                        var ddlOptions = $(this).closest('.settingItem').find('#' + ddlId).children('option').map(function(){ return this.value}).toArray();
                        options.optionalFilters.oFiltersSelections = _.difference(options.optionalFilters.oFiltersSelections, ddlOptions);

                        // set useOFilters to false if all filter options are unchecked
                        var splitFilterChks = $('#' + ddlId).closest('#divTargetReportFilterSettingsSection').find('input[id^="chkTargetReportOFilters_"]:checked').length;
                        options.optionalFilters.useOFilters = splitFilterChks > 0 ? true : false;

                        $('#' + ddlId).hide();
                    }
                });

                $('#' + ddlId).unbind("change").bind('change', function () {
                    updateSelectionsFromDropdown($('#' + ddlId));
                });
            }

            function configureHFilterSection(treeContainer, chk, useFilter, selections, settings) {
                chk.attr('checked', useFilter);

                Helpers.perfJSonCall({
                    method: 'GetHFilterSelectionMode',
                    data: { reportID: reportId },
                    service: "GeneralSettings",
                    successCallback: function (hFilterSelectionMode) {
                        // Configure HFilter Tree
                        setNodesSelections(settings.SettingItems, selections);
                        createTree(treeContainer, settings.SettingItems, settings, hFilterSelectionMode)
                        
                        treeContainer.css('display', !chk.is(':checked') ? 'none' : '');
                        treeContainer.closest('.settingItem').show();
                    }
                });
            }

            function setNodesSelections(hFiltersForLink, selections) {
                var selectedIDs = [];
                
                if (selections && selections.SettingItems) {
                    selectedIDs = selections.SettingItems.map(function(settingItem) {
                        return parseInt(settingItem.DisplayID, 10);
                    });

                    // Set selected nodes
                    hFiltersForLink.forEach(function(node) {
                        var nodeId = parseInt(node.DisplayID, 10);
                        
                        if (selectedIDs.indexOf(nodeId) > -1)
                            node.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
                        else
                            node.Attributes = Storyboard.Constants.Attributes.None;
                    })
                } else {
                    // Deselect all nodes
                    hFiltersForLink.forEach(function(node) {
                        node.Attributes = Storyboard.Constants.Attributes.None;
                    });
                }
            }

            function createTree(treeContainer, hFiltersForLink, settings, hFilterSelectionMode) {
                var isSingleSelect = hFilterSelectionMode !== Storyboard.Constants.HFilterSelectionModes.MULTIPLE;

                function getHFilter(array, key, value) {
                    for (var item in array)
                        if (array[item][key].toString() === value.toString())
                            return array[item];
                    return null;
                }

                function toggleNode(el) {
                    var nodeId = el.val();
                    var hFiltersSelections = options.optionalFilters && options.optionalFilters.hFiltersSelections ?
                                                options.optionalFilters.hFiltersSelections :
                                                { SettingItems: [] };

                    var node = getHFilter(hFiltersForLink, 'DisplayID', nodeId);
                    var settingItem = getHFilter(hFiltersSelections.SettingItems, 'DisplayID', nodeId);

                    if (el.is(':checked')) {
                        node.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
                        if (isSingleSelect) 
                            hFiltersSelections.SettingItems = [];
                        if (isSingleSelect || !settingItem) {
                            hFiltersSelections.SettingItems.push({
                                DisplayID: node.DisplayID,
                                DisplayName: node.DisplayName,
                                Path: node.Path
                            });
                        }
                    } else {
                        node.Attributes = Storyboard.Constants.Attributes.None;
                        if (isSingleSelect) 
                            hFiltersSelections.SettingItems = [];
                        else if (settingItem) {
                            hFiltersSelections.SettingItems = hFiltersSelections.SettingItems.filter(function(settingItem) {
                                return settingItem.DisplayID != node.DisplayID;
                            });
                        }
                    }

                    options.optionalFilters.hFiltersSelections = hFiltersSelections;
                }

                $(treeContainer).html('<ul></ul>');
                var tree = $(treeContainer).children('ul');
                tree.DUITreeView({
                    singleSelection: isSingleSelect,
                    check: toggleNode
                });
    
                //Add root hFilter element and direct children
                var rootId = 0, tmpChildNodes = [];
                for (var i in hFiltersForLink) {
                    var o = hFiltersForLink[i];
                    if (o.ParentSettingItemId == 0) {
                        rootId = o.DisplayID;
                        tree.DUITreeView('renderRootNode', {
                            selected: true,
                            child: {
                                name: o.DisplayName.replace(/'/g, "\\'"),
                                value: o.DisplayID,
                                checked: (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled)
                            }
                        });
                        break;
                    }
                }
    
                for (var j in hFiltersForLink) {
                    var e = hFiltersForLink[j];
                    if (e.ParentSettingItemId == rootId) {
                        tmpChildNodes.push({
                            name: e.Name.replace(/'/g, "\\'"),
                            value: e.DisplayID,
                            checked: (e.Attributes == Storyboard.Constants.Attributes.IsUserEnabled)
                        });
                    }
                }
    
                tree.DUITreeView('renderChildNodes', {
                    children: tmpChildNodes
                });

                tree.find('input + span[onclick]').removeAttr('onclick');
    
                // Attach events
                tree.unbind('expanded').bind('expanded', function (evt, params) {
                    var node = params.node, parentId = params.value, nodes = [];
                    for (var i in hFiltersForLink) {
                        var o = hFiltersForLink[i];
                        if (o.ParentSettingItemId == parentId) {
                            nodes.push({
                                name: o.Name.replace(/'/g, "\\'"),
                                value: o.DisplayID,
                                checked: (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled)
                            });
                        }
                    }
    
                    tree.DUITreeView('renderChildNodes', {
                        node: node.children('span'),
                        children: nodes
                    });

                    tree.find('input + span[onclick]').removeAttr('onclick');
                });
            }

            function configure(storyboardSettingss) {
                var storyboardSettings = storyboardSettingss.d;
                var settingTypes = sb.Constants.SettingTypes;

                $('#divTargetReportFilterSettingsSection').children('.settingItem').hide();
                $('#chkTargetReportFilters').closest('.settingItem').hide();

                $.each(storyboardSettings, function () {
                    var setting = this,
                        optionsHtml = [],
                        optionTemplate = '<option value="{value}">{text}</option>';

                    // Get select options
                    if (setting.SettingType === settingTypes.VariableSubset ||
                        setting.SettingType === settingTypes.Interval ||
                        setting.SettingType === settingTypes.MovingAverage) {
                        $.each(setting.SettingItems, function () {
                            var settingItem = this;
                            if (settingItem.Attributes !== 0)
                                optionsHtml.push(optionTemplate.replace('{value}', settingItem.DisplayID).replace('{text}', settingItem.DisplayName));
                        });
                    } else if (setting.SettingType === settingTypes.TimePeriod) {
                        $.each(setting.SettingItems, function () {
                            var settingItem = this;
                            if (settingItem.Attributes !== 0 && settingItem.DisplayID !== "0" && settingItem.DisplayID !== "27" && !settingItem.IsDynamic)
                                optionsHtml.push(optionTemplate.replace('{value}', settingItem.DisplayID).replace('{text}', settingItem.DisplayName));
                        });
                    } else if (setting.SettingType === settingTypes.Filter) {
                        $.each(setting.SettingItems, function () {
                            var settingItem = this;
                            if (settingItem.Attributes !== 0 && settingItem.SubItems && settingItem.SubItems.length) {
                                $.each(settingItem.SubItems, function () {
                                    var subItem = this;
                                    if (subItem.Attributes !== 0)
                                        optionsHtml.push(optionTemplate.replace('{value}', subItem.DisplayID).replace('{text}', subItem.DisplayName));
                                });
                            }
                        });
                        if (setting.HasNoSelection && optionsHtml.length > 0)
                            optionsHtml.unshift(optionTemplate.replace('{value}', '0-0').replace('{text}', 'No selection'));
                    }

                    if (setting.SettingType === settingTypes.VariableSubset) {
                        configureFilterSubSection(
                            $('#ddlTargetReportVariableSubsets'),
                            $('#chkTargetReportVariableSubsets'),
                            options.optionalFilters && options.optionalFilters.useVariableSubset,
                            options.optionalFilters.variableSubsetSelections,
                            optionsHtml,
                            setting.IsMultiSelect);
                    } else if (setting.SettingType === settingTypes.Interval) {
                        configureFilterSubSection(
                            $('#ddlTargetReportIntervals'),
                            $('#chkTargetReportIntervals'),
                            options.optionalFilters && options.optionalFilters.useIntervals,
                            options.optionalFilters.intervalSelections,
                            optionsHtml,
                            setting.IsMultiSelect);
                    } else if (setting.SettingType === settingTypes.MovingAverage) {
                        configureFilterSubSection(
                            $('#ddlTargetReportMovingAverage'),
                            $('#chkTargetReportMovingAverage'),
                            options.optionalFilters && options.optionalFilters.useMovingAverage,
                            options.optionalFilters.movingAverageSelections,
                            optionsHtml,
                            setting.IsMultiSelect);
                    } else if (setting.SettingType === settingTypes.Filter) {
                        if (!setting.IsSplitBoxes) {
                            configureFilterSubSection(
                                $('#ddlTargetReportOFilters'),
                                $('#chkTargetReportOFilters'),
                                options.optionalFilters && options.optionalFilters.useOFilters,
                                options.optionalFilters.oFiltersSelections,
                                optionsHtml,
                                setting.IsMultiSelect);
                        } else {
                            var settingItemsReversed = setting.SettingItems.reverse();
                            $.each(settingItemsReversed, function () {
                                if (this.Attributes !== 0 && this.SubItems && this.SubItems.length)
                                    configureSplitedFilterSubsection(this, options, optionTemplate);
                            });
                        }
                    } else if (setting.SettingType === settingTypes.TimePeriod) {
                        configureFilterSubSection(
                            $('#ddlTargetReportTimePeriods'),
                            $('#chkTargetReportTimePeriods'),
                            options.optionalFilters && options.optionalFilters.useTimePeriods,
                            options.optionalFilters.timePeriodsSelections,
                            optionsHtml,
                            setting.IsMultiSelect);
                    } else if (setting.SettingType === settingTypes.HFilter) {
                        configureHFilterSection(
                            $('#targetReportTree'),
                            $('#chkTargetReportHFilters'),
                            options.optionalFilters && options.optionalFilters.useHFilters,
                            options.optionalFilters.hFiltersSelections,
                            setting
                        );
                    }
                });

                if (storyboardSettings.length > 0) {
                    $('#chkTargetReportFilters').closest('.settingItem').show();

                    if ($('#chkTargetReportFilters').is(':checked'))
                        $('#divTargetReportFilterSettingsSection').show();
                }
            }

            $.when(this.getStoryboardSettingsDF(reportId, 'Configuring default optional filters...'))
                .then(configure);
        },

        getStoryboardSettingsDF: function (reportId, message) {
            return Helpers.perfJSonCall({
                method: 'GetStoryboardSettingsForLinks',
                data: { reportID: reportId },
                message: message,
                service: "GeneralSettings"
            });
        },

        bindFilterSectionEvents: function () {
            var leEvent = this;

            function getSelectedValues(el) {
                var values = [];
                if ($(el).attr("multiple")) values = $(el).val() || [];
                else values = $(el).val() ? [$(el).val()] : [];
                return values;
            }

            $("#chkTargetReportFilters").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || { };

                if ($(this).is(':checked')) {
                    leEvent.options.useOptionalFilters = true;
                    leEvent.configureFilterSection($('#ddlLayoutElementLinkReports').val());
                } else {
                    delete leEvent.options.useOptionalFilters;
                    $('#divTargetReportFilterSettingsSection').hide()
                }
            });

            // #region Variable Subsets
            $("#chkTargetReportVariableSubsets").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || { };

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useVariableSubset = true;
                    leEvent.options.optionalFilters.variableSubsetSelections = getSelectedValues('#ddlTargetReportVariableSubsets');
                    $('#ddlTargetReportVariableSubsets').show();
                } else {
                    delete leEvent.options.optionalFilters.useVariableSubset;
                    delete leEvent.options.optionalFilters.variableSubsetSelections;
                    $('#ddlTargetReportVariableSubsets').hide();
                }
            });

            $("#ddlTargetReportVariableSubsets").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters.variableSubsetSelections = getSelectedValues(this);
            });
            // #endregion

            // #region Intervals
            $("#chkTargetReportIntervals").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || { };

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useIntervals = true;
                    leEvent.options.optionalFilters.intervalSelections = getSelectedValues('#ddlTargetReportIntervals');
                    $('#ddlTargetReportIntervals').show();
                } else {
                    delete leEvent.options.optionalFilters.useIntervals;
                    delete leEvent.options.optionalFilters.intervalSelections;
                    $('#ddlTargetReportIntervals').hide();
                }
            });

            $('#ddlTargetReportIntervals').unbind("change").bind('change', function () {
                leEvent.options.optionalFilters.intervalSelections = getSelectedValues(this);
            });
            // #endregion

            // #region Moving Average
            $("#chkTargetReportMovingAverage").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || {};

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useMovingAverage = true;
                    leEvent.options.optionalFilters.movingAverageSelections = getSelectedValues('#ddlTargetReportMovingAverage');
                    $('#ddlTargetReportMovingAverage').show();
                } else {
                    delete leEvent.options.optionalFilters.useMovingAverage;
                    delete leEvent.options.optionalFilters.movingAverageSelections;
                    $('#ddlTargetReportMovingAverage').hide();
                }
            });

            $('#ddlTargetReportMovingAverage').unbind("change").bind('change', function () {
                leEvent.options.optionalFilters.movingAverageSelections = getSelectedValues(this);
            });
            // #endregion

            // #region Optional Filters
            $("#chkTargetReportOFilters").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || {};

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useOFilters = true;
                    leEvent.options.optionalFilters.oFiltersSelections = getSelectedValues('#ddlTargetReportOFilters');
                    $('#ddlTargetReportOFilters').show();
                } else {
                    delete leEvent.options.optionalFilters.useOFilters;
                    delete leEvent.options.optionalFilters.oFiltersSelections;
                    $('#ddlTargetReportOFilters').hide();
                }
            });

            $('#ddlTargetReportOFilters').unbind("change").bind('change', function () {
                leEvent.options.optionalFilters.oFiltersSelections = getSelectedValues(this);
            });
            // #endregion

            // #region Time Period
            $("#chkTargetReportTimePeriods").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || {};

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useTimePeriods = true;
                    leEvent.options.optionalFilters.timePeriodsSelections = getSelectedValues('#ddlTargetReportTimePeriods');
                    $('#ddlTargetReportTimePeriods').show();
                } else {
                    delete leEvent.options.optionalFilters.useTimePeriods;
                    delete leEvent.options.optionalFilters.timePeriodsSelections;
                    $('#ddlTargetReportTimePeriods').hide();
                }
            });

            $('#ddlTargetReportTimePeriods').unbind("change").bind('change', function () {
                leEvent.options.optionalFilters.timePeriodsSelections = getSelectedValues(this);
            });
            // #endregion

            // #region HFilter
            $("#chkTargetReportHFilters").unbind("change").bind("change", function () {
                leEvent.options.optionalFilters = leEvent.options.optionalFilters || {};

                if ($(this).is(':checked')) {
                    leEvent.options.optionalFilters.useHFilters = true;
                    leEvent.options.optionalFilters.hFiltersSelections = { SettingItems: [] };
                    $('#targetReportTree').show();
                } else {
                    delete leEvent.options.optionalFilters.useHFilters;
                    delete leEvent.options.optionalFilters.hFiltersSelections;
                    $('#targetReportTree').hide();
                }
            });
            // #endregion
        },

        enable: function() {
            var leEvent = this;
            var linkType;

            if (this.options.back) linkType = "Back";
            else if (this.options.url) linkType = "Url";
            else if (this.options.isActionPlan) {
                if (!Storyboard.GeneralSettings.hasFormReports())
                    return;

                linkType = "APLink";
                leEvent.configureActionPlanSection(Helpers.getReportID());
            }
			else if (this.options.isDrilldown) {
				if (!Storyboard.GeneralSettings.hasDrilldownReports())
					return;
				linkType = "DrilldownLink";
			} else {
				if ($('> option[value="SBLink"]', $('#ddlLayoutElementLinkType')).length > 0)
					linkType = "SBLink";
				else
					linkType = $('> option:selected', $('#ddlLayoutElementLinkType')).val();
			}

            $(".layoutElementLinkType").show();
            $("#ddlLayoutElementLinkType").removeAttr("disabled").val(linkType);
            
            $("#chkLayoutElementLinkEvent").attr("checked", true)
                .bind("change.disable", function() {
                    if (!this.checked) {
                        $('#divTargetReportFilterSettings').hide();
                        leEvent.destroy();
                    }
                });

            $("#ddlLayoutElementLinkType").bind("change", function() {
                var linkType = $(this).val();
                leEvent.setDefaults();
                leEvent["enable" + linkType]();

                if (linkType === 'SBLink')
                    $('#divTargetReportFilterSettings').show();
                else
                    $('#divTargetReportFilterSettings').hide();

                if (linkType === 'APLink')
                    leEvent.configureActionPlanSection(Helpers.getReportID());
            });

            $('#chkLayoutElementPopoverEvent').attr('disabled', true);

            leEvent["enable" + linkType]();
        },

		enableSBLink: function () {
            delete this.options.isDrilldown;
            delete this.options.isActionPlan;
			this.enableReportLink(10);
        },

        enableAPLink: function () {
            delete this.options.isDrilldown;
            this.options.isActionPlan = true;
            this.enableReportLink(13);
        },

		enableDrilldownLink: function () {
            this.options.isDrilldown = true;
			this.enableReportLink(19);
        },

		enableReportLink: function (reportTypeId) {
            var leEvent = this;
            var isActionPlan = leEvent.options.isActionPlan;

            if (!isActionPlan) {
                UserEvents.showMarkersMessage(leEvent.element.id == 'chartPreview');

                $(".layoutElementSBLinkEvent").show();
                $(".layoutElementUrlEvent").hide();
            } else {
                $(".layoutElementAPLinkEvent").show()
                $(".layoutElementSBLinkEvent").hide();
                $(".layoutElementUrlEvent").hide();
            }

			$("#ddlLayoutElementLinkReports").bind("change", function () {
                if (!isActionPlan)
					UserEvents.showMarkersMessage(leEvent.element.id == 'chartPreview');

                leEvent.options.report = $(this).val();
                if (leEvent.options.isDrilldown) {
                    $('#divTargetReportFilterSettings').hide();
                } else if (isActionPlan) {
                    $('#divTargetReportFilterSettings').hide();
                } else {
					$('#divTargetReportFilterSettings').show();
					if (leEvent.options.useOptionalFilters) {
						leEvent.configureFilterSection($('#ddlLayoutElementLinkReports').val());
					} else {
						$('#divTargetReportFilterSettingsSection').hide();
					}
                }

                if (!isActionPlan)
					leEvent.loadElements();
            });

            $("#ddlLayoutElementLinkAP").bind("change", function () {
                leEvent.options.report = $(this).val();
                $('#divTargetReportFilterSettings').hide();
            });

            if (!isActionPlan) {
                $("#ddlLayoutElementLinkElements").bind("change", function () {
                    if ($('option:selected', this).hasClass('slideItem')) {
                        delete leEvent.options.element;
                        leEvent.options.slide = $(this).val();
                    } else {
                        leEvent.options.slide = $('option:selected', this).prevAll('.slideItem:first').val();
                        leEvent.options.element = $(this).val();
                    }
                });
            }

            if (isActionPlan) {
                this.loadReports(reportTypeId, $("#ddlLayoutElementLinkAP"));
            } else {
                this.loadReports(reportTypeId, $("#ddlLayoutElementLinkReports"));
                this.bindFilterSectionEvents();
            }
		},

        enableUrl: function() {
			var leEvent = this;
			delete this.options.isDrilldown;
			UserEvents.showMarkersMessage(leEvent.element.id == 'chartPreview');

            this.options.openInNewWindow = (typeof this.options.openInNewWindow !== 'undefined')
                                            ? this.options.openInNewWindow
                                            : true;

            $(".layoutElementUrlEvent").show();
            $(".layoutElementSBLinkEvent").hide();
            $(".layoutElementAPLinkEvent").hide();
            $("#txtLayoutElementLinkUrl")
                .val(this.options.url || "http://")
                .bind("change", function() {
                    var url = $(this).val();
                    
                    if (new RegExp("^((f|ht)tps?:)?//", "i").test(url) === false) {
                        url = 'http://' + url;
                        $(this).val(url);
                    }

                    leEvent.options.url = url;
                });

            $("#chkLayoutElementLinkOpenInNewWindow")
                .attr("checked", this.options.openInNewWindow)
                .bind("change", function() {
                    leEvent.options.openInNewWindow = this.checked;
                });
        },

        enableBack: function() {
            if (!this.options.back) this.options.back = true;
            delete this.options.isDrilldown;
            $(".layoutElementSBLinkEvent").hide();
            $(".layoutElementAPLinkEvent").hide();
            $(".layoutElementUrlEvent").hide();
        },

        disable: function() {
            $("#ddlLayoutElementLinkType").attr("disabled", true).val("SBLink");
            $(".layoutElementLinkType").hide();
            $(".layoutElementUrlEvent").hide();
            $(".layoutElementSBLinkEvent").hide();
            $(".layoutElementAPLinkEvent").hide();

            $("#txtLayoutElementLinkUrl").val('');
            $("#chkLayoutElementLinkEvent").attr("checked", false);

            $('#layoutElementUserEvents .layoutElementPopoverEvent').css('display', '');
            $('#chkLayoutElementPopoverEvent').attr('disabled', false);

            this.disableReportFilters();
        },

        disableReportFilters: function() {
            $('#divTargetReportFilterSettings').hide();
            $('#chkTargetReportFilters').removeAttr('checked');

            $('#divTargetReportFilterSettingsSection').find(':checkbox').attr('checked', false);
            $('#divTargetReportFilterSettingsSection').find('select').each(function () {
                $(this).val('');
            });
        },

        destroy: function() {
            this.unbind();
            this.disable();
            UserEvents.removeEvent(this.element, this);
        }
    };


    var StyleEvent = function(element, options){
        this.options = options;
        this.element = element;
        this.options.type = "hover";
        this.options.name = "Style";
        this.namespace = "mouseenter." + UserEvents.dataKey + "." + this.options.key + 
                        " mouseleave." + UserEvents.dataKey + "." + this.options.key;
    };

    StyleEvent.prototype = {

        constructor: StyleEvent,

        trigger: function(event) {
            if (this.element.nodeName.toUpperCase() === "SVG") this.triggerIconShapeStyle(event);
			if (this.element.nodeName.toUpperCase() === "DIV") {
                if ($(this.element).hasClass('layoutElementStaticText'))
					this.triggerTextStyle(event);
				else if ($(this.element).find('.layoutElementChart').length > 0)
					this.triggerChartStyle(event);
				else if ($(this.element).find('.layoutElementSimpleTable').length > 0)
					this.triggerTableStyle(event);
				else if ($(this.element).find('#divChart').length > 0) {
					if (ChartSetupDataBinding.GetBoundContentType() == Storyboard.Constants.itemTypes.CHART)
						this.triggerChartStyle(event);
					else
						this.triggerTableStyle(event);
				}
			}
        },

        triggerIconShapeStyle: function(event) {
            var options = this.options;
            var targetElement = options.key === "padding" ? 
                                this.element.parentNode : 
                                this.element.querySelector(".group-styles");

            function set() {
                if (typeof options.originalValue !== "undefined") return; 
                
                switch (options.key) {
                    case "color":
                        options.originalValue = targetElement.getAttribute("fill");
                        IconShapeUI.setColor({color: options.value}, targetElement);
                        break;
                    case "opacity":
                        options.originalValue = targetElement.getAttribute("opacity");
                        options.originalValue = options.originalValue ? options.originalValue * 100 : 100;
                        IconShapeUI.setOpacity(options.value, targetElement);
                        break;
                    case "padding":
                        var iconPath = targetElement.querySelector(".path-icon"), 
                            transform, originalValue;

                        if (iconPath) {
                            transform = iconPath.getAttribute('transform');
                            if (transform)
                                originalValue = parseFloat(transform.split('scale(')[1].split(')')[0], 10);
                        }

                        options.originalValue = originalValue ? (-((100 * originalValue) - 100) / 2) : 0;
                        IconShapeUI.setPadding(options.value, targetElement);
                        break;
                    default:
                }

                options.active = true;
            }

            function unset() {
                switch (options.key) {
                    case "color":
                        IconShapeUI.setColor({color: options.originalValue}, targetElement);
                        break;
                    case "opacity":
                        IconShapeUI.setOpacity(options.originalValue, targetElement);
                        break;
                    case "padding":
                        IconShapeUI.setPadding(options.originalValue, targetElement);
                        break;
                    default:
                }

                delete options.originalValue;
                this.active = false;
            }

            if (targetElement) {
                if (event.type === "mouseenter" || event.type === "mouseover")  set();
                if (event.type === "mouseleave" || event.type === "mouseout")   unset();
            }
        },

        triggerTextStyle: function(event) {
            var element = this.element;
            var key     = this.options.key;
            var value   = this.options.value;

            function set() {
                switch (key) {
                    case "color":
                        $(element).css('color', value);
                        $(element).find('.wrappertext [style]').filter(function() {
                            return ($(this).attr('style').indexOf('color') > -1);
                        }).each(function() {
                            $(this).attr('data-original-color', $(this).css('color')).css('color', value);
                        });
                        break;
                    case "opacity":
                        $(element).css('opacity', parseInt(value, 10) / 100);
                        break;
                    default:
                }
            }

            function unset() {
                switch (key) {
                    case "color":
                        $(element).css('color', '');
                        $(element).find('.wrappertext [data-original-color]').each(function() {
                            $(this).css('color', $(this).attr('data-original-color')).removeAttr('data-original-color');
                        });
                        break;
                    case "opacity":
                        $(element).css('opacity', '');
                        break;
                }
            }

            if (event.type === "mouseenter" || event.type === "mouseover")  set();
            if (event.type === "mouseleave" || event.type === "mouseout")   unset();
		},

		triggerChartStyle: function (event) {
			var element = this.element;
			var key = this.options.key;
			var value = this.options.value;
			var handlerGuid = $('#divChart', element).length > 0 ? 'preview' : $('.layoutElementChart', element).attr('guid');
			var chartHandler = Storyboard.HighchartsWrapper.getChartHandler(handlerGuid);

			function set() {
				switch (key) {
					case 'color':
						if (chartHandler) {
							chartHandler.chartBackground.originalBgColor = $(chartHandler.chartBackground.element).css('fill');
							$(chartHandler.chartBackground.element).css('fill', value);

							chartHandler.plotBackground.originalBgColor = $(chartHandler.plotBackground.element).css('fill');
							$(chartHandler.plotBackground.element).css('fill', value);
						}
						break;
					case 'textColor':
						$(element).find('text').filter(function () {
							return ($(this).attr('style').indexOf('fill') > -1);
						}).each(function () {
							$(this).attr('data-original-color', $(this).css('fill')).css('fill', value);
						});
						break;
				}
			}

			function unset() {
				switch (key) {
					case 'color':
						$(chartHandler.chartBackground.element).css('fill', chartHandler.chartBackground.originalBgColor);						
						$(chartHandler.plotBackground.element).css('fill', chartHandler.plotBackground.originalBgColor);
						break;
					case 'textColor':
						$(element).find('text[data-original-color]').each(function () {
							$(this).css('fill', $(this).attr('data-original-color')).removeAttr('data-original-color');
						});
						break;
				}
			}

			if (event.type === "mouseenter" || event.type === "mouseover") set();
			if (event.type === "mouseleave" || event.type === "mouseout") unset();
		},

		triggerTableStyle: function (event) {
			var element = this.element;
			var key = this.options.key;
			var value = this.options.value;

			function set() {
				switch (key) {
					case 'color':
						$(element).find('td').filter(function () {
							return ($(this).attr('style').indexOf('background-color') > -1);
						}).each(function () {
							$(this).attr('data-original-bg-color', $(this).css('background-color')).css('background-color', value);
						});
						break;
					case 'textColor':
						$(element).find('td').filter(function () {
							return ($(this).attr('style').indexOf('color') > -1);
						}).each(function () {
							$(this).attr('data-original-color', $(this).css('color')).css('color', value);
						});
						break;
				}
			}

			function unset() {
				switch (key) {
					case 'color':
						$(element).find('td[data-original-bg-color]').each(function () {
							$(this).css('background-color', $(this).attr('data-original-bg-color')).removeAttr('data-original-bg-color');
						});
						break;
					case 'textColor':
						$(element).find('td[data-original-color]').each(function () {
							$(this).css('color', $(this).attr('data-original-color')).removeAttr('data-original-color');
						});
						break;
				}
			}

			if (event.type === "mouseenter" || event.type === "mouseover") set();
			if (event.type === "mouseleave" || event.type === "mouseout") unset();
		},

		bindToChart: function () {
			this.bind();
		},

		bindToTable: function () {
			this.bind();
		},

        bind: function() {
            this.unbind();
            $(this.element).bind(this.namespace, $.proxy(this.trigger, this));
        },

        unbind: function() {
            $(this.element).unbind(this.namespace);
        },

        enable: function() {
            var leEvent = this;
            var styleKey = this.options.key[0].toUpperCase() + this.options.key.slice(1);

            Helpers.setupNumericTextbox($("#txtLayoutElementStyleOpacityEvent"));
            Helpers.setupNumericTextbox($("#txtLayoutElementStylePaddingEvent"));

            $("#chkLayoutElementStyle"+ styleKey +"Event")
                .attr("checked", true)
                .bind("change.disable", function() {
                    if (!this.checked) leEvent.destroy();
                });
                
            $("#txtLayoutElementStyle"+ styleKey +"Event")
                .removeAttr("disabled").val(this.options.value || "");

            $("#txtLayoutElementStyle"+ styleKey +"Event").bind("change", function() {
                leEvent.options.value = $(this).val();
                leEvent.bind();
            });

            $("#txtLayoutElementStyle"+ styleKey +"Event").closest(".settingControl").removeClass('invisible');

			if (this.options.key === "color" || this.options.key === "textColor") {
				var colorPickerId = this.options.key === "color" ? '#txtLayoutElementStyleColorEvent' : '#txtLayoutElementStyleTextColorEvent';

				$(colorPickerId)
					.DUIColorPicker({
						layout: 'template',
						selected: {
							colorString: leEvent.options.value,
							templateColorId: leEvent.options.key_color_colorPlaceholderId
						}
					});

				$(colorPickerId)
					.bind("colorChange.DUIColorPicker", function () {
						var color = $(this).DUIColorPicker("get.selectedColor");
						var colorId = $(this).DUIColorPicker("get.selectedColorId");

						leEvent.options.value = color;

						if (colorId) {
							leEvent.options.key_color_colorPlaceholderId = colorId;
						} else {
							leEvent.options.key_color_colorPlaceholderId = undefined;
						}

						leEvent.bind();
					});
			}
        },

        disable: function() {
            var styleKey = this.options.key[0].toUpperCase() + this.options.key.slice(1);

            $("#chkLayoutElementStyle"+ styleKey +"Event").attr("checked", false);
            $("#txtLayoutElementStyle"+ styleKey +"Event").attr("disabled", true).val("");

            $("#txtLayoutElementStyle"+ styleKey +"Event").closest(".settingControl").addClass('invisible');
        },

        destroy: function() {
            this.unbind();
            this.disable();
            UserEvents.removeEvent(this.element, this);
        }
    };


    var TooltipEvent = function(element, options) {
        this.element = element;
        this.options = options;
        this.options.name = "Tooltip";
        this.options.type = "hover";
        this.options.styles = this.options.styles || {};
    };

    TooltipEvent.Default = {
        options: {
            position: "top center",
            tetherOptions: {
                constraints: [
                    {
                        to: 'scrollParent',
                        attachment: 'together',
                        pin: true
                    }
                ]
            }
        },
        styles: {
            backgroundColor:   "rgba(255, 255, 255, 0.9)",
            borderColor:       "transparent",
            borderRadius:      "2px",
            fontFamily:        "Arial",
            fontSize:          "12px",
            color:             "#333333",
            textAlign:         "center",
            fontWeight:        false,
            fontStyle:         false,
            textDecoration:    false
        },
        positions: [
            {position: "top left"},
            {position: "left top"},
            {position: "left middle"},
            {position: "left bottom"},
            {position: "bottom left"},
            {position: "bottom center"},
            {position: "bottom right"},
            {position: "right bottom"},
            {position: "right middle"},
            {position: "right top"},
            {position: "top right"},
            {position: "top center"},
            {position: "middle center"}
        ],
        fonts: [
            {fontFamily: "Arial", fontStack: 'Arial, Helvetica, sans-serif'},
            {fontFamily: "Comic Sans", fontStack: '"Comic Sans MS", cursive, sans-serif'},
            {fontFamily: "Courier New", fontStack: '"Courier New", Courier, monospace'},
            {fontFamily: "Georgia", fontStack: 'Georgia, serif'},
            {fontFamily: "Impact", fontStack: 'Impact, Charcoal, sans-serif'},
            {fontFamily: "Lucida Console", fontStack: '"Lucida Console", Monaco, monospace'},
            {fontFamily: "Palatino Linotype", fontStack: '"Palatino Linotype", "Book Antiqua", Palatino, serif'},
            {fontFamily: "Tahoma", fontStack: 'Tahoma, Geneva, sans-serif'},
            {fontFamily: "Times New Roman", fontStack: '"Times New Roman", Times, serif'},
            {fontFamily: "Trebuchet", fontStack: '"Trebuchet MS", Helvetica, sans-serif'},
            {fontFamily: "Verdana", fontStack: 'Verdana, Geneva, sans-serif'}
        ],
        fontSizes: [
            {fontSize: "10px"},
            {fontSize: "11px"},
            {fontSize: "12px"},
            {fontSize: "13px"},
            {fontSize: "14px"},
            {fontSize: "15px"},
            {fontSize: "16px"},
            {fontSize: "17px"},
            {fontSize: "18px"},
            {fontSize: "19px"},
            {fontSize: "20px"},
            {fontSize: "24px"},
            {fontSize: "28px"},
            {fontSize: "32px"},
            {fontSize: "36px"}
        ]
    };

    TooltipEvent.prototype = {

        constructor: TooltipEvent,
        
        getStyle: function(style) {
            return this.options.styles[style] || TooltipEvent.Default.styles[style];
        },

        setStyle: function(style, value) {
            if (TooltipEvent.Default.styles[style] === value && style !== "fontFamily") delete this.options.styles[style];  // we always need fontFamily style 
            else this.options.styles[style] = value;

            this.bind();
        },

        getFontStack: function(fontFamily) {
            var fonts = TooltipEvent.Default.fonts;
            var fontsLength = fonts.length;

            for (var i = 0; i < fontsLength; i++)
                if (fonts[i].fontFamily === fontFamily)
                    return fonts[i].fontStack;
        },

        getElementColor: function() {
            return  $(this.element).find("> defs stop").attr("stop-color") ||
                    $(this.element).find(".group-styles").attr("fill") || 
                    "transparent";
        },

        //http://jsfiddle.net/ekinertac/3Evx5/1/
        convertHexToGRBA: function(hex, alpha){
            hex = hex.replace('#','');
            var r = parseInt(hex.substring(0,2), 16);
            var g = parseInt(hex.substring(2,4), 16);
            var b = parseInt(hex.substring(4,6), 16);

            var result = 'rgba(' + r + ',' + g + ',' + b + ',' + (parseInt(alpha, 10)/100) +')';
            return result;
        },

        /* http://jsfiddle.net/Mottie/xcqpF/1/light/ */
        convertRGBtoHex: function(color){
            if (color === "transparent" ) return color;

            color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
            return (color && color.length === 4) ? "#" +
                ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
                ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
                ("0" + parseInt(color[3],10).toString(16)).slice(-2) : color;
        },

        getAlphaFromRGBA: function(rgba){
            var alpha = rgba.split(")")[0].split(",")[3] || "1";
            return parseFloat(alpha) * 100;
		},

		bindToChart: function () {
			this.bind();
		},

		bindToTable: function () {
			this.bind();
		},

        bind: function() {
           var leEvent = this;
            var layoutelementid = $(this.element).closest(".layoutElement").attr("layoutelementid") || 0;

            this.unbind();

            if (!this.element || !this.options.text) return;

           this.tooltip = new Tooltip({
                target: this.element,
                content: HTMLHelpers.htmlDecode(this.options.text.replace(/\r?\n/g, '&lt;br&gt;')),
                position: this.options.position || TooltipEvent.Default.options.position,
                tetherOptions: this.options.tetherOptions || TooltipEvent.Default.options.tetherOptions,
                classes: "tooltip-theme-iconshape tooltip-" + layoutelementid,
                remove: true
            });

            this.tooltip.drop.once("open", function() {
                var styles = $.extend({}, leEvent.options.styles);

                if (styles.fontFamily)
                    styles.fontFamily = leEvent.getFontStack(styles.fontFamily);

                $(this.content).css(styles);
                this.position();
            });

            $(this.element).bind("remove." + UserEvents.dataKey, $.proxy(this.unbind, this));
            $(this.element).closest(".layoutElementAdmin").bind("drag", $.proxy(this.tooltip.position, this.tooltip));
        },

        unbind: function() {
            if (this.tooltip) {
                this.tooltip.destroy();
                delete this.tooltip;
            }
        },

        enable: function() {
            var leEvent = this;
            var styles = this.options.styles;
            var name = this.options.name;

            styles.borderColor = styles.borderColor || this.getElementColor();
            styles.fontFamily = styles.fontFamily || (typeof TooltipEvent.Default.styles.fontFamily === 'object' ? 
                TooltipEvent.Default.styles.fontFamily.Name : 
                TooltipEvent.Default.styles.fontFamily);

            $(".layoutElement"+ name +"Event .settingsGroup, "+
              ".layoutElement"+ name +"Event .settingsTable").css('display', '');

            $("#chkLayoutElement"+ name +"Event").attr("checked", true)
                .bind("change.disable", function() {
                    if (!this.checked) leEvent.destroy();
            });

            HTMLHelpers.bindSelect($("#ddlLayoutElement"+ name +"Position"), TooltipEvent.Default.positions, "position", "position");
            HTMLHelpers.bindSelect($("#ddlLayoutElement"+ name +"Font"), TooltipEvent.Default.fonts, "fontFamily", "fontFamily");
            HTMLHelpers.bindSelect($("#ddlLayoutElement"+ name +"FontSize"), TooltipEvent.Default.fontSizes, "fontSize", "fontSize");

            Helpers.setupNumericTextbox($("#txtLayoutElement"+ name +"BackgroundOpacity"));
            Helpers.setupNumericTextbox($("#txtLayoutElement"+ name +"BorderRadius"));

            $("#ddlLayoutElement"+ name +"Position")
                .val(this.options.position || TooltipEvent.Default.options.position)
                .removeAttr("disabled")
                .bind("change", function() {
                    leEvent.options.position = $(this).val();
                    leEvent.bind();
            });

            $("#txtLayoutElement"+ name +"Event")
                .val(HTMLHelpers.htmlDecode(this.options.text))
                .bind("change", function() {
                    leEvent.options.text = HTMLHelpers.htmlEncode($(this).val());
                    leEvent.bind();
            });

            $("#txtLayoutElement"+ name +"BackgroundColor")
                .DUIColorPicker({
                    layout: 'template',
                    selected: {
                        colorString: this.convertRGBtoHex(this.getStyle("backgroundColor")),
                        templateColorId: this.getStyle("backgroundColor_colorPlaceholderId")
                    }
                });

            $("#txtLayoutElement"+ name +"BackgroundColor")
                .bind("colorChange.DUIColorPicker", function(event, color, tcolor, templateColor) {
                    var alpha = $("#txtLayoutElement"+ name +"BackgroundOpacity").val();
                    var backgroundColor = (color === "transparent" ? 
                            leEvent.convertHexToGRBA("#ffffff", alpha) :
                            leEvent.convertHexToGRBA(color, alpha));

                    leEvent.setStyle("backgroundColor", backgroundColor);

                    if (templateColor){
                        leEvent.setStyle("backgroundColor_colorPlaceholderId", templateColor.id);
                    }
                    else {
                        leEvent.setStyle("backgroundColor_colorPlaceholderId", undefined);
                    }
            });

            $("#txtLayoutElement"+ name +"BorderColor")
                .DUIColorPicker({
                    layout: 'template',
                    selected: {
                        colorString: this.getStyle("borderColor"),
                        templateColorId: this.getStyle("borderColor_colorPlaceholderId")
                    }
                });

            $("#txtLayoutElement"+ name +"BorderColor")
                .bind("colorChange.DUIColorPicker", function(event, color, tcolor, templateColor) {
                    leEvent.setStyle("borderColor", color);

                    if (templateColor){
                        leEvent.setStyle("borderColor_colorPlaceholderId", templateColor.id);
                    }else {
                        leEvent.setStyle("borderColor_colorPlaceholderId", undefined);
                    }
            });

            $("#txtLayoutElement"+ name +"BackgroundOpacity")
                .val(this.getAlphaFromRGBA(this.getStyle("backgroundColor")))
                .bind("change", function() {
                    var alpha = $(this).val();
                    var color = $("#txtLayoutElement"+ name +"BackgroundColor").DUIColorPicker("get.selectedColor");
                    var backgroundColor = leEvent.convertHexToGRBA(color, alpha);
                    leEvent.setStyle("backgroundColor", backgroundColor);
            });

            $("#txtLayoutElement"+ name +"BorderRadius")
                .val(this.getStyle("borderRadius").replace("px", ""))
                .bind("change", function() {
                    leEvent.setStyle("borderRadius", $(this).val() + "px");
            });

            $("#ddlLayoutElement" + name + "Font")
                .val(this.getStyle("fontFamily"))
                .bind("change", function() {
                    leEvent.setStyle("fontFamily", $(this).val());
            });

            $("#ddlLayoutElement"+ name +"FontSize")
                .val(this.getStyle("fontSize"))
                .bind("change", function() {
                    leEvent.setStyle("fontSize", $(this).val());
            });

            $("#ddlLayoutElement"+ name +"FontColor")
                .DUIColorPicker({
                    layout: 'template',
                    selected: {
                        colorString: this.getStyle("color"),
                        templateColorId: this.getStyle("color_colorPlaceholderId")
                    }
                });

            $("#ddlLayoutElement"+ name +"FontColor")
                .bind("colorChange.DUIColorPicker", function(event, color, tcolor, templateColor) {
                    leEvent.setStyle("color", color);

                    if (templateColor){
                        leEvent.setStyle("color_colorPlaceholderId", templateColor.id);
                    } else {
                        leEvent.setStyle("color_colorPlaceholderId", undefined);
                    }
            });

            $("#ddlLayoutElement"+ name +"TextAlign")
                .val(this.getStyle("textAlign"))
                .bind("change", function() {
                    leEvent.setStyle("textAlign", $(this).val());
            });

            $("#chkLayoutElement"+ name +"FontStyleBold")
                .attr("checked", !!this.getStyle("fontWeight"))
                .bind("change", function() {
                    leEvent.setStyle("fontWeight", this.checked ? "bold" : false);
            });

            $("#chkLayoutElement"+ name +"FontStyleItalic")
                .attr("checked", !!this.getStyle("fontStyle"))
                .bind("change", function() {
                    leEvent.setStyle("fontStyle", this.checked ? "italic" : false);
            });

            $("#chkLayoutElement"+ name +"FontStyleUnderline")
                .attr("checked", !!this.getStyle("textDecoration"))
                .bind("change", function() {
                    leEvent.setStyle("textDecoration", this.checked ? "underline" : false);
            });

            $(".layoutElement"+ name +"Event .ColorTextbox").DUIcolorPicker({layout: 'template'});

            if (name === 'Popover') {
                $('#chkLayoutElementLinkEvent').attr('disabled', true);
            }
        },

        disable: function() {
            var name = this.options.name;


            $(".layoutElement"+ name +"Event .settingsGroup, "+
              ".layoutElement"+ name +"Event .settingsTable").css('display', 'none');

            $("#ddlLayoutElement"+ name +"Position").val("top center").attr("disabled", true);
            $("#chkLayoutElement"+ name +"Event").attr("checked", false);

            if (name === 'Popover') {
                $('#chkLayoutElementLinkEvent').attr('disabled', false);
            }
        },

        destroy: function() {
            this.unbind();
            this.disable();
            UserEvents.removeEvent(this.element, this);
        }
    };

    var PopoverEvent = function(element, options){
        this.element = element;
        this.options = options;
        this.options.name = "Popover";
        this.options.type = "click";
        this.options.styles = this.options.styles || {};
    };

    PopoverEvent.prototype = $.extend({}, TooltipEvent.prototype);
    PopoverEvent.prototype.constructor = PopoverEvent;

    PopoverEvent.prototype.bindToChart = function(chartOptions) {
        this.bind();

        if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview() || window.IsMyStories) {
            if (chartOptions) {
                var linkEvent = this;

                chartOptions.chart.events = $.extend(
                    chartOptions.chart.events,
                    {
                        click: function () {
                            if (linkEvent.popover) {
                                linkEvent.popover.toggle();
                            }
                        }
                    }
                );
            }
        }
    }

    PopoverEvent.prototype.bind = function() {
        var leEvent = this;
        var layoutelementid = $(this.element).closest(".layoutElement").attr("layoutelementid") || 0;

        this.unbind();

        if (!this.element || !this.options.text) return;

        this.popover = new Drop({
            target: this.element,
            content: HTMLHelpers.htmlDecode(this.options.text.replace(/\r?\n/g, '&lt;br&gt;')),
            position: this.options.position || TooltipEvent.Default.options.position,
            classes: "drop-theme-iconshape drop-" + layoutelementid,
            openOn: "click",
            tetherOptions: {
                constraints: [
                    {
                        to: 'scrollParent',
                        attachment: 'together',
                        pin: true
                    }
                ]
            },
            remove: true
        });

        this.popover.on("open", function() {
            var tooltipEvent = UserEvents.findEvent(leEvent.element, "Tooltip");
            if (tooltipEvent && tooltipEvent.tooltip) 
                $(tooltipEvent.tooltip.drop.drop).css("visibility", "hidden");
        });

        this.popover.once("open", function() {
            var styles = $.extend({}, leEvent.options.styles);

            if (styles.fontFamily)
                styles.fontFamily = leEvent.getFontStack(styles.fontFamily);

            $(this.content).css(styles);
            this.position();
        });

        this.popover.on("close", function() {
            var tooltipEvent = UserEvents.findEvent(leEvent.element, "Tooltip");
            if (tooltipEvent && tooltipEvent.tooltip) 
                $(tooltipEvent.tooltip.drop.drop).css("visibility", "");
        });

        $(this.element).bind("remove." + UserEvents.dataKey, $.proxy(this.unbind, this));
        $(this.element).closest(".layoutElementAdmin").bind("drag", $.proxy(this.popover.position, this.popover));
    };

    PopoverEvent.prototype.unbind = function() {
        if (this.popover) {
            this.popover.destroy();
            delete this.popover;
        }
    };


    sb.LayoutDesigner.UserEvents = UserEvents;

})(window.Storyboard = (window.Storyboard || {}));